export enum SellabilityRange {
  UP_TO_50_MQ = 'UP_TO_50_MQ',
  BETWEEN_50_AND_85_MQ = 'BETWEEN_50_AND_85_MQ',
  BETWEEN_85_AND_115_MQ = 'BETWEEN_85_AND_115_MQ',
  BETWEEN_115_AND_145_MQ = 'BETWEEN_115_AND_145_MQ',
  OVER_145_MQ = 'OVER_145_MQ',
}
